import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { type SupportZendeskTicketModel } from "@doitintl/cmp-models";
import { Chip, Link, Stack, Tooltip } from "@mui/material";

import { useCustomerId } from "../../../../Components/hooks/useCustomerId";
import { getStatusColor } from "../../../../Support/Components/TicketsFilterTable/TicketsTableColumns";
import { transformStatus } from "../../../../utils/common";

export const TicketRow = ({
  zendeskTicket,
  isLastItem,
}: {
  zendeskTicket: SupportZendeskTicketModel;
  isLastItem: boolean;
}) => {
  const customerId = useCustomerId();
  const history = useHistory();
  const { t } = useTranslation("services");

  const { id, status, subject } = zendeskTicket.ticket;

  return (
    <Tooltip title={subject}>
      <Stack
        direction="row"
        spacing={1}
        flex={1}
        alignSelf="flex-start"
        sx={{
          borderBottom: isLastItem ? "none" : "1px solid",
          borderColor: "divider",
          width: "100%",
          cursor: "pointer",
        }}
        alignItems="center"
        justifyContent="space-between"
        onClick={() => {
          history.push(`/customers/${customerId}/support/tickets/${id}`);
        }}
      >
        <Link color="inherit" underline="always" variant="body2" noWrap sx={{ maxWidth: "80%" }}>
          {subject}
        </Link>
        <Chip variant="status" color={getStatusColor(status)} label={transformStatus(status, t)} />
      </Stack>
    </Tooltip>
  );
};
